import { pagesConfig } from '../../../shared/pages-config';
import { useUserSettings } from '../../../utils/use-user-settings';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';
import ChromeDevicesPaginatedGrid from './chrome-devices-paginated-grid';

export default function ChromeDevicesPage() {
  const { toolsRoles, changeLogRoles, viewType } = useUserSettings();

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.devices.name },
        { label: pagesConfig.chromeDevices.name },
      ]}
      bookmarkKey={pagesConfig.chromeDevices.value}
    >
      <ChromeDevicesPaginatedGrid
        key={viewType.chromeDevicesGridStates?.activeGridState || 'default'}
        toolsRoles={toolsRoles}
        changeLogRoles={changeLogRoles}
      />
    </SimpleBreadcrumbsPage>
  );
}
